const rejectIfNecessary = (promiseSettledResults) => {
  const rejectedReasons = promiseSettledResults.filter((result) => result.status === "rejected").map((result) => result.reason);
  if (rejectedReasons.length > 0) {
    throw rejectedReasons[0];
  }
};
export {
  rejectIfNecessary
};
//# sourceMappingURL=rejectIfNecessary.js.map
